module.exports = __webpack_public_path__ + "img/service_notice.ce2842c.webp";